import { SchemaTypes } from '@genial/schemas';
import { Utils } from '@genial/utils';

import { mountAccount } from '../../../../../store/customer/normalize';
import { orderResumePdfTemplate, setupPDF } from '../../../../Resume/utils';
import { OrderPdfTypes, ProductTypeProps } from '../../../../Resume/utils/types';
import { OrderHistoryItemProps, messageError } from '../../constants';

export interface OrderHistoryMainItemComponentProps {
  item: OrderHistoryItemProps;
  onSelect(item: OrderHistoryItemProps): void;
}

export interface OrderHistoryItemComponentProps extends OrderHistoryMainItemComponentProps {
  isReferencedByBasket: boolean;
  onBasketPress: () => void;
}

export const formatDate = (v: SchemaTypes.DateISO | Date, mask = 'dd/MM/yyyy HH:mm') =>
  v ? Utils.Mask.DateFormat(v, mask) : messageError;

export const formatMoney = (v: number) => (v || v === 0 ? Utils.Mask.Money(v) : messageError);

export const handleExportNewOrder = (item: OrderHistoryItemProps) => {
  const orderName = item?.orderName ? `${item?.orderName}` : messageError;
  const operationType = item?.side === 'V' ? 'Venda' : 'Compra';

  const operationName =
    item?.offer?.fantasyName && item?.offer?.asset
      ? `${item?.offer?.fantasyName} ${item?.offer?.asset}`
      : messageError;

  const minimumApplication = item?.offer?.minimumApplication
    ? Utils.Mask.Money(item?.offer?.minimumApplication)
    : messageError;

  const estimatedNetValue =
    item.executedAmount !== undefined &&
    item.executedAmount !== null &&
    item.offer.expectedIR !== undefined &&
    item.offer.expectedIR !== null
      ? Utils.Mask.Money(item.executedAmount - item.offer.expectedIR)
      : messageError;

  const custodyAccount = mountAccount(
    item?.account?.pnpAccountNumber || 0,
    item?.account?.pnpAccountDigit
  );

  const quotationDate =
    item?.offer?.requestedDateQuotation?.quotationDate || item?.offer?.quotationDate;
  const liquidationDate =
    item?.offer?.requestedDateQuotation?.liquidityDate || item?.offer?.liquidationDate;

  const data = {
    orderName,
    orderDate: item?.orderDate,
    orderAmount: item?.amount,
    minimumApplication,
    productDisplay:
      item?.offer?.productDisplayNormalized ||
      item?.offer?.productNameNormalized ||
      item?.offer?.productDisplay ||
      item?.offer?.productName,
    accountNumber: item?.customer.customerId,
    riskRatingName:
      item?.offer?.riskRatingName ||
      item?.offer?.riskRating ||
      item?.offer?.suitabilityProductRisk?.risk ||
      messageError,
    maturityDate: item?.offer?.maturityDate,
    liquidityIndicator:
      item?.offer?.liquidityIndicatorNormalized || item?.offer?.liquidityIndicator,
    profitabilityToMaturity: item?.offer?.profitabilityToMaturity,
    feesPayment: item?.offer?.feesPaymentNormalized || item?.offer?.feesPayment,
    qualifiedInvestor: item?.offer?.qualifiedInvestor,
    riskRating: item?.offer?.riskRating,
    redemptionDescription: item?.offer?.redemptionDescription,
    administrationFee: item?.offer?.administrationFee,
    profitabilityTwelveMonthsAdjusted: item?.offer?.profitabilityTwelveMonthsAdjusted?.toString(),
    quotationRedemptionTermFormatted: item?.offer?.quotationRedemptionTermFormatted,
    productName: item?.offer?.productName || messageError,
    symbol: item?.offer?.symbol || messageError,
    lastPrice: item?.offer?.lastPrice || messageError,
    priceChangeTax: item?.offer?.priceChangeTax || 0,
    orderQuantity: item?.quantity || messageError,
    tradeDate: item?.offer?.tradeDate || messageError,
    orderPrice: item?.requestedPrice || 0,
    orderType: item?.orderType,
    operationName,
    strategy: item?.offer?.strategy || messageError,
    additionalInfo: item?.offer?.additionalInfo || [],
    applicationIn: item?.offer?.applicationIn || messageError,
    titleName: item?.offer?.titleName || messageError,
    settlementDate: item?.offer?.settlementDate,
    operationType,
    redemptionDate: item?.offer?.redemptionDate || messageError,
    netFinancialValue: item?.offer?.netFinancialValue || messageError,
    ir: item?.offer?.ir || messageError,
    estimatedNetValue,
    custodyAccount,
    quotationDate: quotationDate
      ? Utils.Mask.DateFormat(quotationDate, 'dd/MM/yyyy')
      : messageError,
    liquidationDate: liquidationDate
      ? Utils.Mask.DateFormat(liquidationDate, 'dd/MM/yyyy')
      : messageError,
    customerFeeAmount: item?.requestedOfferDetail?.customerFeeAmount
      ? Utils.Mask.Percentage(item.requestedOfferDetail.customerFeeAmount)
      : messageError,
    customerPuAmount: item?.requestedOfferDetail?.customerPuAmount
      ? Utils.Mask.Money(item.requestedOfferDetail.customerPuAmount, { maximumFractionDigits: 8 })
      : messageError,
  } as unknown as OrderPdfTypes;

  setupPDF(
    orderResumePdfTemplate(data as unknown as OrderPdfTypes, item.marketType as ProductTypeProps),
    `ordem-${item.orderHash}.pdf`
  );
};
